import { fetchGetOnlineAccount } from '@iwoca/lapi-client/edge';
import { AlertBox } from '@iwoca/orion';
import { FallbackBankSVG } from '@svgComponents/fallbackBankSVG';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';

import messages from './TrueLayer.messages';
import styles from './trueLayer.module.css';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';

const TrueLayerLinkedAccounts = () => {
    const stateKey = useStateKey();
    const {
        isLoading,
        data: onlineAccountsResponse,
        isError
    } = useQuery({
        queryKey: ['online_accounts', stateKey],
        queryFn: () => fetchGetOnlineAccount({ stateKey: stateKey })
    });

    if (isError || isLoading) return null;

    // Take the most recent OpenBankingOnlineAccount data only
    const { provider, accounts, status } = onlineAccountsResponse.data[0] || {};

    if (status && status.code !== 'active') return null;

    if (accounts && accounts.length > 0)
        return (
            <div data-testid="truelayerLinkedAccounts">
                {accounts.map((account) => {
                    const { account_number } = account.extra as {
                        account_number: string;
                    };

                    return (
                        <AlertBox
                            key={account_number}
                            variant="connect"
                            className={styles.linkedAccount}
                        >
                            <FallbackBankSVG
                                className={styles.linkedAccountIcon}
                            />

                            <p className={styles.linkedAccountHeading}>
                                <FormattedMessage
                                    {...messages.linkedAccountHeading}
                                    values={{
                                        providerName: provider
                                            ? `${provider} `
                                            : '',
                                        accountNumber: account_number.substring(
                                            account_number.length - 4
                                        )
                                    }}
                                />
                            </p>
                        </AlertBox>
                    );
                })}
            </div>
        );

    return null;
};

// eslint-disable-next-line import/no-default-export
export default TrueLayerLinkedAccounts;
